import { useId, type JSX } from 'react'
import { useFormContext } from 'react-hook-form'
import { InputTextarea } from 'primereact/inputtextarea'

interface Props {
  name: string
  label: string
  helpText?: string
  placeholder?: string
  rows?: number
  cols?: number
  autoFocus?: boolean
  disabled?: boolean
  required?: boolean
}

export function FormTextarea({ name, label, helpText, required, ...rest }: Props): JSX.Element {
  const { register, formState: { errors } } = useFormContext()
  const error = errors[name]
  const errorMessage = typeof error?.message === 'string' ? error.message : undefined
  const id = useId()
  const errorId = `${id}-error`
  const helpId = `${id}-help`
  const describedBy = [helpText && helpId, errorMessage && errorId].filter(Boolean).join(' ') || undefined

  return (
    <div className="flex flex-col gap-1 mb-3">
      <label htmlFor={id} className="text-sm font-medium">
        {label}{required && <span aria-hidden> *</span>}
      </label>
      <InputTextarea
        id={id}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={describedBy}
        {...register(name)}
        {...rest}
      />
      {helpText && <small id={helpId} className="text-gray-500">{helpText}</small>}
      {errorMessage && (
        <small id={errorId} role="alert" className="text-red-600">{errorMessage}</small>
      )}
    </div>
  )
}
